
export enum BeaconItemStatusCd {
	NEW = 'New',
	READ = 'Read'}
